import gql from 'graphql-tag';

const NAME = 'compositions_CustomersWidget_searchCustomersQuery';

export default gql`
  query ${NAME} (
    $searchString: String,
    $billTo: String,
  ) {
    searchCustomers (
      filters: {
        searchString: $searchString
        billTo: $billTo,
      }
    ) {
      billTo
      city
      id
      name
      shipTo
      state
      terminalNumber
    }
  }
`;



// WEBPACK FOOTER //
// ./src/compositions/CustomerWidget/searchCustomersQuery.js